import React, { useState, useEffect, useContext } from "react";
import viewBookInfo from "../BookModule.module.css";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import toast from "react-hot-toast";
import moment from "moment";
import { R_PER_PAGE } from "../../../../../labels";
import CardTemplate from "../CardTemplate";
import { CartContext } from "../../../../../context/CartItems";
import { WishListContext } from "../../../../../context/WishListItems";

export default function Wishlist() {
  let page = R_PER_PAGE;
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const { cartNotify } = useContext(CartContext);
  const { WishNotify } = useContext(WishListContext);
  // total table data  with pages
  const totalPages = Math.ceil(listData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = listData?.slice(start, end);

  useEffect(() => {
    loadListdata();
  }, []);

  const loadListdata = () => {
    setIsLoading(true);
    AxiosInstance.post("/api/book/view_all_books", {
      search: "",
      category_id: "",
      group_course_id: "",
      subject_id: "",
      medium: "",
      is_set: "",
      view_all_book: 0,
      user_id: userid,
      book_id: "",
      popularity: 0,
      book_type: 0,
    })
      .then((res) => {
        if (res.data.status) {
          const datasaAddOn = res?.data.data.map((data) => ({
            ...data,
          }));
          setListData(datasaAddOn);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  };

  // wishlist
  // Toggle wishlist status
  const toggleWishlist = (bookId, currentStatus) => {
    const payload = {
      user_id: userid,
      book_id: bookId,
      is_favorite: currentStatus == 1 ? 0 : 1, // Toggle is_favorite value
      created_by: userid,
      created_dt: moment().format("YYYY-MM-DD"),
    };

    AxiosInstance.post("/api/book/wishlist/add", payload)
      .then((res) => {
        if (res.data.status) {
          loadListdata(); // Reload data after successful toggle

          WishNotify(userid);
        } else {
          console.error("Failed to update wishlist:", res.data.message);
        }
      })
      .catch((error) => {
        console.error("Error updating wishlist:", error);
      });
  };

  const handleAddCart = (bookIds) => {
    AxiosInstance.post("/api/book/cart/add", {
      id: "",
      user_id: userid,
      book_id: bookIds,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          loadListdata();
          cartNotify(userid);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        return error;
      });
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div className="BathHeader global_container">
        {/* heading */}
        <div className="header_portion">
          <h2 className="TitleHeader">Wishlist</h2>
        </div>
        {/* card portion */}
        <div className={`col-xl-12 col-lg-12   col-md-12  col-12 col-sm-12`}>
          <div className={`row  ${viewBookInfo.BookborderRed} mx-0`}>
            {currentData.length > 0 ? (
              currentData.map((iop) => (
                <div className="col-lg-3 col-12 mb-2">
                  <CardTemplate
                    items={iop}
                    handleSubmitCart={handleAddCart}
                    toggleWish={toggleWishlist}
                  />
                </div>
              ))
            ) : (
              <p className="st_confirm_label ms-1 text-center mt-4 mb-4 ">
                No books to display
              </p>
            )}
          </div>
          <div className="row mx-0">
            <div
              className={`col-md-12 ${viewBookInfo.paginationSection} ${viewBookInfo.BookborderRed}`}
            >
              <Pagination
                Isbook={true}
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  listData && listData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  listData && listData?.length > 0
                    ? listData?.length < currentPage * rowsPerPage
                      ? listData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  listData && listData?.length > 0 ? listData?.length : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${viewBookInfo.prev_buttonViewAllbook} ${viewBookInfo.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={totalPages == 0 || currentPage === totalPages}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
